import React, { useContext } from 'react';

import styled from 'styled-components';

import Loadable from '../common/loadable';
import HeaderBodyFooterLayout from '../layout/HeaderBodyFooterLayout';
import Body from './Body';
import { DownloadContext } from './context/DownloadContext';
import Footer from './Footer';
import Header from './Header';

const StyledLayout = styled(HeaderBodyFooterLayout)`
    /* Common / shared styles. */
    a,
    a:visited,
    a:focus,
    a:hover {
        color: ${(props) => props.theme.colors.primary.main};
    }
    a:hover {
        text-decoration: underline;
    }
    header,
    footer {
        a,
        a:visited,
        a:focus {
            color: ${(props) => props.theme.colors.text.main};
            text-decoration: none;
        }
        a:hover {
            color: ${(props) => props.theme.colors.primary.main};
            text-decoration: underline;
        }
    }

    /* Layout styles. */
    row-gap: 1px; // Safari needs this or the shadow under the header menu gets obscured by content on scroll.
    > header {
        background-color: ${(props) => props.theme.colors.gray};
        padding: 8px 16px;
        box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
            0px 1px 1px rgba(0, 0, 0, 0.14),
            0px 1px 3px rgba(0, 0, 0, 0.12);
        display: flex;
    }
    
    .HeaderBodyFooterLayout-ScrollableArea > footer > div {
        display: flex;
        width: 100%;
        padding: 8px 16px;
        background-color: ${(props) => props.theme.colors.gray};
    }
    
    /* Responsive stuff */
    @media only screen
        and (max-width: 768px) {
        .HeaderBodyFooterLayout-ScrollableArea main > div{
            grid-template-columns: 100%;
        }
        #header-links {
            display: none;
        }
        
        .main-column-body {
            width: calc(100% - 12px);
        }
        
        .hero-title {
            font-size: 20px;
        }
        
        footer > div {
            flex-direction: column;
            height: 80px;
        }
        
        #footer-links {
            flex-direction: row;
            justify-content: center;
        }
        
        #footer-copyright {
            text-align: center;
            margin: 0;
        }
    }
`;

const DownloadView: React.FC = () => {
    const { isLoading } = useContext(DownloadContext);
    return (
        <Loadable fullScreen={true} isLoading={isLoading} hideContentOnLoading={true}>
            <StyledLayout
                headerContent=<Header/>
                bodyContent=<Body/>
                footerContent=<Footer/>
            />
        </Loadable>
    );
};

export default DownloadView;
